import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./Components/Home";
import Publications from "./Components/Publications";
import PageNotFound from "./Components/404";
import NavBar from "./Components/NavBar";
import Gallery from "./Components/Gallery";
import Contact from "./Components/Contact";
import Academics from "./Components/Academics";
import Research from "./Components/Research";
import Work from "./Components/WorkExperience";
import CommunityService from "./Components/CommunityService";
import Visits from "./Components/StudyVisits";
import Conferences from "./Components/Conferences";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/academics" element={<Academics />} />
        <Route path="/research" element={<Research />} />
        <Route path="/work-experience" element={<Work />} />
        <Route path="/community-service" element={<CommunityService />} />
        <Route path="/visits" element={<Visits />} />
        <Route path="/conferences" element={<Conferences />} />

        <Route path="*" element={PageNotFound} />
      </Routes>
    </div>
  );
}

export default App;
